module.exports = __webpack_public_path__ + "img/Account.371e7f88.svg";